/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetGetConfiguratorQueryResponse, GetGetConfiguratorPathParams, GetGetConfiguratorQueryParams, GetGetConfigurator404 } from "../../models/GetGetConfigurator";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetGetConfiguratorUrl({ code }: { code: GetGetConfiguratorPathParams["code"] }) {
  const res = { method: 'GET', url: `/api/v1/products/${code}/configurator` as const }  
  return res
}

/**
 * {@link /api/v1/products/:code/configurator}
 */
export async function getGetConfigurator({ code, params }: { code: GetGetConfiguratorPathParams["code"]; params: GetGetConfiguratorQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetGetConfiguratorQueryResponse, ResponseErrorConfig<GetGetConfigurator404>, unknown>({ method : "GET", url : getGetGetConfiguratorUrl({ code }).url.toString(), params, ... requestConfig })  
  return res.data
}